<template><span></span></template>

<script>
import VueTypes from 'vue-types';

export default {
  name: 'PageTitle',
  props: {
    title: VueTypes.string,
  },
  watch: {
    title(to) {
      this.setTitle(to);
    },
  },
  mounted() {
    this.setTitle();
  },
  beforeUnmount() {
    this.setTitle('');
  },
  methods: {
    setTitle(title = this.title) {
      document.title = title ? `${title} - ${this.APP_NAME}` : this.APP_NAME;
    },
  },
};
</script>

<style lang="scss"></style>
